/* =========================================================
   CasaTextil - Auto seleccionar opción 2 al cambiar Color
   - Funciona con tu snippet main-product-variant-picker.liquid
   - Si el usuario cambia la opción 1 (Color), selecciona automáticamente
     el primer valor disponible de la opción 2 (Metros/Kilos/etc.) para ese color
   - No toca rollos ni tus scripts de precio
   ========================================================= */

(function () {
  // Evita correr varias veces
  if (window.__CT_AUTO_PICK_OPTION2_INSTALLED) return;
  window.__CT_AUTO_PICK_OPTION2_INSTALLED = true;

  function getVariantDataFromPicker(pickerEl) {
    // En tu snippet: <script type="application/json">{{ product.variants | json }}</script>
    const jsonEl = pickerEl.querySelector('script[type="application/json"]');
    if (!jsonEl) return null;
    try {
      return JSON.parse(jsonEl.textContent || '[]');
    } catch (e) {
      return null;
    }
  }

  function getSelectedValueByPosition(pickerEl, position) {
    // position: 1 = option1, 2 = option2...
    const selector = `input[type="radio"][name][id][checked], input[type="radio"][name][id]:checked`;
    const radios = Array.from(pickerEl.querySelectorAll('input[type="radio"]'));

    // Ojo: tus radios tienen name="{{ option.name }}" y el fieldset está en loop.
    // Para inferir "posición", usamos el orden visual de fieldsets.
    const fieldsets = Array.from(pickerEl.querySelectorAll('fieldset.product-form__input--fieldset'));
    const fs = fieldsets[position - 1];
    if (!fs) return null;

    const checked = fs.querySelector('input[type="radio"]:checked');
    return checked ? checked.value : null;
  }

  function setSelectedValueByPosition(pickerEl, position, valueToSelect) {
    const fieldsets = Array.from(pickerEl.querySelectorAll('fieldset.product-form__input--fieldset'));
    const fs = fieldsets[position - 1];
    if (!fs) return false;

    // si hay radios disabled por disponibilidad, evitamos seleccionarlos
    const radios = Array.from(fs.querySelectorAll('input[type="radio"]'));
    const target = radios.find(r => String(r.value) === String(valueToSelect) && !r.classList.contains('disabled') && !r.disabled);
    if (!target) return false;

    if (!target.checked) {
      target.checked = true;
      // Dispara change para que <variant-radios> actualice variante y UI
      target.dispatchEvent(new Event('change', { bubbles: true }));
    }
    return true;
  }

  function findFirstAvailableOption2ForOption1(variants, option1Value) {
    // variants vienen como objetos Shopify:
    // { available, option1, option2, option3, ... }
    // Queremos: primer variant disponible con option1 == option1Value
    const matches = variants.filter(v => v && v.available && String(v.option1) === String(option1Value));
    if (!matches.length) return null;

    // Elegimos el primer option2 (puedes cambiar a "menor cantidad" si quieres)
    const first = matches[0];
    return first.option2 || null;
  }

  function isProductRollo() {
    const titleEl =
      document.querySelector('.product__title') ||
      document.querySelector('h1') ||
      document.querySelector('[data-product-title]');
    const t = (titleEl ? titleEl.textContent : '') || '';
    const d = t.toLowerCase();
    return d.includes('x rollo') || d.includes('x rollos');
  }

  function initForPicker(pickerEl) {
    // Solo tiene sentido si hay 2+ fieldsets (Color + Metros/Kilos)
    const fieldsets = pickerEl.querySelectorAll('fieldset.product-form__input--fieldset');
    if (!fieldsets || fieldsets.length < 2) return;

    // Si es rollo, no tocamos nada (tu flujo rollo ya está fino)
    if (isProductRollo()) return;

    const variants = getVariantDataFromPicker(pickerEl);
    if (!Array.isArray(variants) || !variants.length) return;

    // Detectar cambios en el picker
    pickerEl.addEventListener('change', (ev) => {
      const input = ev.target;
      if (!input || input.type !== 'radio') return;

      // Queremos reaccionar SOLO cuando cambia la Opción 1 (primer fieldset)
      const fieldsetsArr = Array.from(pickerEl.querySelectorAll('fieldset.product-form__input--fieldset'));
      const firstFs = fieldsetsArr[0];
      if (!firstFs) return;

      if (!firstFs.contains(input)) return; // no es cambio de Color (opción 1)

      const option1Value = getSelectedValueByPosition(pickerEl, 1);
      if (!option1Value) return;

      const option2Current = getSelectedValueByPosition(pickerEl, 2);

      // Si ya hay option2 seleccionada que sea válida con ese color, no forzamos.
      const stillValid = variants.some(v => v.available && String(v.option1) === String(option1Value) && String(v.option2) === String(option2Current));
      if (stillValid) return;

      const desiredOption2 = findFirstAvailableOption2ForOption1(variants, option1Value);
      if (!desiredOption2) return;

      setSelectedValueByPosition(pickerEl, 2, desiredOption2);
    }, true);

    // Fix inicial: al cargar, si por algún motivo está en combinación inválida, corrige
    setTimeout(() => {
      const option1Value = getSelectedValueByPosition(pickerEl, 1);
      if (!option1Value) return;

      const option2Current = getSelectedValueByPosition(pickerEl, 2);
      const stillValid = variants.some(v => v.available && String(v.option1) === String(option1Value) && String(v.option2) === String(option2Current));
      if (stillValid) return;

      const desiredOption2 = findFirstAvailableOption2ForOption1(variants, option1Value);
      if (!desiredOption2) return;

      setSelectedValueByPosition(pickerEl, 2, desiredOption2);
    }, 80);
  }

  function boot() {
    // Tu snippet renderiza: <variant-radios ...>
    const pickers = Array.from(document.querySelectorAll('variant-radios'));
    if (!pickers.length) return;

    pickers.forEach(initForPicker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
